<template>
  <div id="offers">
    <h1 class="page-title">{{ $t("Offers.title_page") }}</h1>
    <div class="row">
      <div class="col-12">
        <filters :isManager="isManager"
                 @offersFiltersChanged="filtersChanged"
                 :initFilters="filters"
                 :isLoading="offerList.loading"
                 :exportIsLoading="offerList.exportLoading"
                 key="offers-list-filters"
                 @exportCSV="exportOffersFile('csv')"
                 @exportXLS="exportOffersFile('xls')"></filters>
      </div>
      <div class="col-12">
        <router-link :to="{ name: 'RequestHistories'}"
                     class="pull-right m-r-50 view-history">
          <u>{{ $t("Offers.view_history") }}</u>
        </router-link>
      </div>
    </div>

    <div>
      <tab-header :isManager="isManager"
                  :numberByStatus="numberByStatus"
                  :tabsList="tabsList"
                  :isLoading="offerList.loading"
                  @offersTabChanged="tabChanged"></tab-header>
      <offer-list :isManager="isManager"
                  :offers="offerList"
                  :status="status"
                  :canEditContract="canEditContract"
                  :contractTemplates="contractTemplates"
                  :selectedEntityId="selectedEntityId"
                  :isLoading="offerList.loading"
                  @offersPageChanged="pageChanged"
                  @offersSortChanged="sortChanged"></offer-list>
    </div>
  </div>
</template>

<script type="text/javascript">
  import offers_mixin from '@/mixin/offers'

  export default {
    mixins: [offers_mixin],
    data() {
      return {
        managerTabs: ['all', 'published', 'waiting', 'validated', 'draft'],
        candidateTabs: ['published', 'waiting', 'validated']
      }
    },
    computed: {
      tabsList: function(){
        return this.isManager ? this.managerTabs : this.candidateTabs
      }
    },
    methods: {
      initTab: function(){
        if (this.isManager) {
          if (this.managerTabs.includes(this.status)) {
            if (this.canEditContract) {
              this.reloadContractTemplates()
            }
            this.reloadOffers()
            return;
          } else {
            this.tabChanged('all')
          }
        } else {
          if (this.candidateTabs.includes(this.status)) {
            this.reloadOffers()
            return;
          } else {
            this.tabChanged('published')
          }
        }
      }
    }
  }
</script>

<style type="text/css">
  .fa-lightbulb-o {
    font-size: 2rem;
  }

  .guideline {
    font-size: 12px;
  }

  .view-history {
    font-size: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/Offers.vue